module.exports = __webpack_public_path__ + "img/thumbs-up-green.83cf961f.svg";